import zhCH from "./i18n/interface/zh-CN.js"
import zhTW from "./i18n/interface/zh-TW.js"
import fr from "./i18n/interface/fr.js"
import de from "./i18n/interface/de.js"
import ru from "./i18n/interface/ru.js"
import store from './store'

const textmap = {
    "zh-TW": zhTW,
    "zh-CN": zhCH,
    "fr": fr,
    "de": de,
    "ru": ru
}
const translator = {
    languages: [
        {
            text: "English",
            value: "en"
        },
        {
            text: "Français",
            value: "fr"
        },
        {
            text: "Deutsch",
            value: "de"
        },
        {
            text: "繁體中文",
            value: "zh-TW"
        },
        {
            text: "简体中文",
            value: "zh-CN"
        },
        {
            text: "Русский",
            value: "ru"
        }

    ],
    texts: {},
    currentLang: "en",
    translate: function (text) {
        let label = text
        if(store.getters&&store.getters.labelTextOverride&&store.getters.labelTextOverride[label]){
            label=store.getters.labelTextOverride[label]
        }
        if (this.currentLang === "en"){
            return label
        }
        return this.texts[label] ? this.texts[label] : label
    },
    setup: function () {
        let defaultLanguage=process.env.VUE_APP_DEFAULT_LANGUAGE&&process.env.VUE_APP_DEFAULT_LANGUAGE!=="" ? process.env.VUE_APP_DEFAULT_LANGUAGE : "en"
        let storedLang = localStorage.getItem('currentLang')
        if (!storedLang || this.languages.filter(x => x.value === storedLang).length === 0) {
            storedLang = defaultLanguage
            localStorage.setItem('currentLang', defaultLanguage)
        }
        this.currentLang = storedLang
        if (storedLang !== "en") {
            this.texts = textmap[storedLang]
        }
    }
}


export default translator
